/// <reference types="vite/client" />
import { configureStore } from '@reduxjs/toolkit';


import authReducer from './authSlice';
import { apiSlice } from '@/services/api';
import '@/services/company-settings.api';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['auth/setPermissions'],
      },
    }).concat(apiSlice.middleware),
  devTools: import.meta.env.MODE !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
